import axios from "axios";
import { UNSAVE_JOB_REQUEST_URL } from "../utils";

export const unsaveJobRequest = async (jobRequestId: string) => {
  return await axios.post(UNSAVE_JOB_REQUEST_URL, {
    jobRequestId,
  });
};
